'use client';

import { useMount } from 'react-use';

export const ScrollToTopOnMount = () => {
  useMount(() => {
    window.scrollTo(0, 0);
  });
  return null;
};
